import type { PluginDefinition } from '@/plugins/types';
import { APP_VERSION } from '@/app/version';
import { ConnectionStatusIndicator } from './ConnectionStatusIndicator';

/**
 * Built-in plugin that renders live database connection status indicators
 * (Neo4j, Qdrant, PostgreSQL) in the application footer status bar.
 *
 * This plugin is internal and locked — it cannot be disabled by the user.
 */
export const connectionStatusPlugin: PluginDefinition = {
  id: 'connection-status',
  name: 'Connection Status',
  version: APP_VERSION,
  description: 'Live-Status für Neo4j-, Qdrant- und PostgreSQL-Verbindungen in der Statusbar.',
  internal: true,
  locked: true,
  group: 'core',
  initializationOrder: 5,
  initialize: () => undefined,
  slots: {
    footerStatus: () => <ConnectionStatusIndicator />,
  },
};
